import PropTypes from 'prop-types';
import { FaCheck } from 'react-icons/fa';
import clsx from 'clsx';
import { memo, useCallback, useState } from 'react';
import Filter from '../../../Filters/Filter';
import Dropdown from '../../../Dropdown';

const CustomDropDown = ({ label, options, onChange, noOptionsMessage }) => {
  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = useCallback(
    (value) => {
      if (value === selectedValue) {
        setSelectedValue('');
        onChange('');
      } else {
        setSelectedValue(value);
        onChange(value);
      }
    },
    [onChange, selectedValue],
  );

  const getLabel = () => {
    if (!options.length) {
      return `${label}: ${noOptionsMessage}`;
    }
    return selectedValue ? `${label}: ${selectedValue}` : label;
  };

  return (
    <Filter
      menuWidthClass="w-64"
      label={getLabel()}
      isFilterEmpty={!selectedValue}
      variant="outline"
      handleClear={() => {
        setSelectedValue('');
        onChange('');
      }}
      filterSpacingClass="py-2 px-3"
      fontSize="text-base"
      filterMaxWidthClass=""
      disabled={!options || !options.length}
    >
      <div
        style={{
          maxHeight: '60vh',
          overflowY: 'auto', // Enable vertical scrolling
        }}
      >
        {options.map((item) => (
          <Dropdown.Item
            withGridLayout={false}
            key={item}
            label={item}
            value={item}
            variant="select"
          >
            <button
              type="button"
              onClick={() => handleChange(item)}
              className="p-1 focus:outline-none text-left center flex"
            >
              <div
                className={clsx('p-1 self-center justify-self-center', {
                  invisible: item !== selectedValue,
                })}
              >
                <FaCheck className="-ml-2 mr-2" />
              </div>
              <div>
                <div className="font-bold">{item}</div>
              </div>
            </button>
          </Dropdown.Item>
        ))}
      </div>
    </Filter>
  );
};

CustomDropDown.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  noOptionsMessage: PropTypes.string,
};

CustomDropDown.defaultProps = {
  label: undefined,
  options: [],
  noOptionsMessage: 'No options',
};

export default memo(CustomDropDown);
